export const CURRENCIES = {
  default: 'EUR',
};
